import InnerComponent from '@Components/Settings/Workflow';
import orgContainer from '@Components/AppContainer';

const Workflow = () => ((orgContainer(InnerComponent)));
export default Workflow;
